import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { handleImage } from "helpers/functions";

const Layout = (props) => {
  return (
    <div className="main-wrapper">
      <Header logo={handleImage(props?.logo)} />
      <Sidebar logo={handleImage(props?.logo)} />
      <div className="content-wrap" id="content-wrapper">
        {props.children}
        <Outlet />
      </div>
    </div>
  );
};
export default Layout;
